import axios from 'axios';

// Get API endpoint from environment variable, with fallback to localhost for development
export const API_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.videoplussensors.com/api'
    : 'http://localhost:8080/api');

export const axiosInstance = axios.create({
  baseURL: API_ENDPOINT,
  withCredentials: true,
});

export const convertStringJsonToObject = (stringJson) => JSON.parse(stringJson.toString());
